function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.998 7.001c5.434-.08 10.87 3.51 14.21 7.027l.003.003c.508.54.789 1.24.789 1.967a2.87 2.87 0 01-.789 1.967l-.003.003c-3.263 3.44-8.686 7.112-14.21 7.03-5.524.082-10.945-3.59-14.207-7.03l-.002-.003A2.87 2.87 0 011 15.998c0-.726.281-1.427.789-1.967l.003-.003c3.336-3.516 8.772-7.107 14.206-7.027zM3.274 15.314a1 1 0 00-.274.684 1 1 0 00.274.684c3.117 3.287 8.033 6.477 12.707 6.402h.034c4.674.075 9.592-3.115 12.711-6.402a1 1 0 00.274-.684 1 1 0 00-.273-.684c-3.188-3.354-8.12-6.472-12.712-6.398h-.034c-4.592-.074-9.524 3.044-12.707 6.398z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 20a4 4 0 100-8 4 4 0 000 8zm0 2a6 6 0 100-12 6 6 0 000 12z",
  fill: "currentColor"
})));